import i18n from '@/lang/index'
var list=require('@/assets/images/erp/cartonorder.jpeg')
export const columnData = [
    {
        key: 'sn',
        text: i18n.t('invoicesCenter.configbutionOrderno'),
        width: '230px',
        fixed: 'left'
    },
    {
        key: 'stateDesc',
        text: i18n.t('invoicesCenter.configbutionState'),
        width: '200px',
        fixed: 'left',
        remind: {
            text: `
            ${i18n.t('invoicesCenter.configbutionStatedraft')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatepresubmit')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatereleased')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatepicking')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatepickcompleted')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatepacking')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatepackcompleted')}<br/>
            ${i18n.t('invoicesCenter.configbutionStateshipped')}<br/>&#12288;&#12288;&#12288;&#12288;&#12288;&#12288;&#12288;&#12288;${i18n.t('invoicesCenter.configbutionStateshippeddetail')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatesigned')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatechecking')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatestockin')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatecancelled')}<br/>
            ${i18n.t('invoicesCenter.configbutionStatecancelapply')}<br/>
`,
            style: {
                width: '450px',
                'font-size': '12px',
                'text-align': 'left',
                'z-index': '999'
            }
        },
        template: () => {
            return ` <div style="display:flex;align-items:center;">
            <span v-if="row.state ==0" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
            <span v-else-if="row.state == 12 || row.state == 4  || row.state == 6 || row.state == 8|| row.state == 14" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#43D268;"></span>
            <span v-else-if="row.state == 5 || row.state == 7 || row.state == 11" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#FF9000;"></span>
            <span v-else-if="row.state == 1 ||  row.state == 9" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#067CF2;"></span>
            <span v-else-if="row.state == 2||row.state==10" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#BD73D3;"></span>
            <span v-else-if="row.state == 19" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
            <span v-else style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#999;"></span>
            <span>{{row.stateDesc}}</span>
        </div>`
        }
    },
    {
        key: 'ifDiscrepancy',
        text: i18n.t('invoicesCenter.configbutionHasdiscrepancy'),
        width: '270px',
        template: () => {
            return `
                <div>{{row.ifDiscrepancy === 'Y' ? '${i18n.t('invoicesCenter.configbutionYes')}' : '${i18n.t('invoicesCenter.configbutionNo')}'}}</div>
            `
        }
    },
    { key: 'updateTime', text: i18n.t('invoicesCenter.configbutionUpdatetime'), width: '180px', sorting: '' },
    {
        key: 'warehouseName',
        text: i18n.t('invoicesCenter.configbutionSender'),
        width: '180px'
    },
    {
        key: 'externalSystemSn1',
        text: i18n.t('invoicesCenter.configbutionBoxorderno'),
        width: '200px',
        remind: {
            text: `
           <img src='${list}' style='height: 100%;width: 100%'/>
  </div>
    
`,
            style: {
                width: '450px',
                height:'400px',
            }
        },
    },

    { key: 'marketName', text: i18n.t('invoicesCenter.configbutionReceiver'), width: '180px' },
    {
        key: 'outNum',
        text: i18n.t('invoicesCenter.configbutionIncomingquantity'),
        width: '200px',
        template: (e, row) => {
            return `<span>{{row.outNum==='0'?'':row.outNum}}<span>`
        }
    },
    {
        key: 'inNum',
        text: i18n.t('invoicesCenter.configbutionStockinquantity'),
        width: '200px',
        template: (e, row) => {
            return `<span>{{row.inNum==='0'?'':row.inNum}}<span>`
        }
    },
    { key: 'logisticPackageNum', text: i18n.t('invoicesCenter.configbutionOrderpackagecount'), width: '220px' },
    { key: 'outPackageNum', text: i18n.t('invoicesCenter.configbutionShippedpackagecount'), width: '200px',
        template: (e, row) => {
            return `<span>{{row.outPackageNum==='0'?'':row.outPackageNum}}<span>`
        }
    },
    { key: 'logisticPackageCheckNum', text: i18n.t('invoicesCenter.configbutionReceivedpackagecount'), width: '200px' },
    { key: 'logisticPackageNoCheckNum', text: i18n.t('invoicesCenter.configbutionUnreceivedpackagecount'), width: '220px' },
    {
        key: 'intoStockDifferNum',
        text: i18n.t('invoicesCenter.configbutionStockindifference'),
        width: '220px',
        template: (e, row) => {
            return `<span style="color:red">{{row.intoStockDifferNum==='0'?'':row.intoStockDifferNum}}<span>`
        }
    },
    { key: 'goodsPrincipalName', text: i18n.t('invoicesCenter.configbutionGoodsmanager'), width: '150px' },
    { key: 'remark', text: i18n.t('invoicesCenter.configbutionRemark') , width: '160px'},
    { key: 'createUserName', text: i18n.t('invoicesCenter.configbutionCreator'), width: '150px' },
    {
        key: 'createTime',
        text: i18n.t('invoicesCenter.configbutionCreatetime'),
        width: '160px',
        sorting: 'DESC',
    },

    { key: 'updateUserName', text: i18n.t('invoicesCenter.configbutionModifier'), width: '150px' }
]
export const options = {
    searchItem: [
        {
            id: '1',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectstateplaceholder'),
            label: i18n.t('invoicesCenter.configbutionState'),
            value: ['9','10','11'],
            resField: 'state',
            multiple: true,
            list: [
                { value: '9', name: i18n.t('invoicesCenter.configbutionStateshippedtext') },
                { value: '10', name: i18n.t('invoicesCenter.configbutionStatesignedtext') },
                { value: '11', name: i18n.t('invoicesCenter.configbutionStatecheckingtext') },
                { value: '14', name: i18n.t('invoicesCenter.configbutionStatestockintext') },
                { value: '19', name: i18n.t('invoicesCenter.configbutionStatecancelapplytext') },
                { value: '0', name: i18n.t('invoicesCenter.configbutionStatecancelled') }
            ]
        },
        {
            id: 'ifDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectplaceholder'),
            label: i18n.t('invoicesCenter.configbutionFilterdiscrepancy'),
            value: '',
            resField: 'ifDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.configbutionYes') },
                { value: 'N', name: i18n.t('invoicesCenter.configbutionNo') }
            ]
        },
        {
            id: 'hasDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectplaceholder'),
            label: i18n.t('invoicesCenter.configbutionHasdiscrepancyrecord'),
            value: '',
            resField: 'hasDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.configbutionYes') },
                { value: 'N', name: i18n.t('invoicesCenter.configbutionNo') }
            ]
        },
        {
            id: '2',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionInputordernoplaceholder'),
            label: i18n.t('invoicesCenter.configbutionOrdernolabel'),
            value: '',
            resField: 'snList'
        },
        {
            id: '3',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionInputexpressnoplaceholder'),
            label: i18n.t('invoicesCenter.configbutionExpressnolabel'),
            value: '',
            resField: 'expressNo'
        },
        {
            id: 'external',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionInputboxordernoplaceholder'),
            label: i18n.t('invoicesCenter.configbutionBoxorderno'),
            value: '',
            resField: 'externalSystemSn1'
        },
        // {
        //     id: 'receiverInfoIds',
        //     type: 'selectEntre',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择',
        //     label: '发货方',
        //     value: [],
        //     resField: 'receiverInfoIds',
        //     multiple: true,
        //     filterable: true,
        //     remote: true,
        //     remoteMethod: 'fetchEntrepot'
        // },
        {
            id: 'warehouseIdList',
            type: 'warehouse',
            placeholder: i18n.t('invoicesCenter.configbutionSelectsenderplaceholder'),
            label: i18n.t('invoicesCenter.configbutionSender'),
            value: [],
            resField: 'warehouseId'
        },
        {
            // id: 'goodsNo',
            // type: 'goodsNoSelector',
            // placeholder: '请选择货号',
            // label: '货号搜索',
            // modelKey: 'goodsNo',
            // multiple: true, //单选
            // // value: '', //单选
            // value: [],//多选
            // resField: 'spuList'
            id: 'goodsNo',
            type: 'goodsNoSelector',
            placeholder: i18n.t('invoicesCenter.configbutionInputgoodsnoplaceholder'),
            label: i18n.t('invoicesCenter.configbutionGoodsnolabel'),
            modelKey: 'goodsNo',
            multiple: true,
            value: '',
            inputShow: true,
            slectShow: false,
            resField: 'spuList'
        },
        // {
        //     id: '7',
        //     type: 'selectUser',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择创建人',
        //     label: '创建人',
        //     value: '',
        //     resField: 'createUserId',
        //     list: [],
        //     filterable: true,
        //     remote: true,
        //     remoteMethod: 'userList'
        // },
        {
            id: "UserInput",
            type: "input",
            size: "small",
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionInputcreatorplaceholder'),
            label: i18n.t('invoicesCenter.configbutionCreator'),
            value: "",
            resField: "createUserName",
        },
        // {
        //     id: '82',
        //     type: 'selectUser',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择商品负责人',
        //     label: '商品负责人',
        //     value: '',
        //     resField: 'goodsLeader',
        //     list: [],
        //     filterable: true,
        //     remote: true,
        //     remoteMethod: 'userList'
        // },
        {
            id: 'goodsLeader',
            type: 'select',
            size: 'small',
            clearable: true,
            multiple: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectgoodsmanagerplaceholder'),
            label: i18n.t('invoicesCenter.configbutionGoodsmanager'),
            value: '',
            filterable:true,
            resField: 'goodsLeaderList',
            list: []
        },
        // {
        //     id: 'goodsLeader',
        //     type: 'input',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请输入商品负责人姓名',
        //     label: '商品负责人',
        //     value: '',
        //     resField: 'goodsLeader'
        // },
        {
            id: '8',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectcreatetimeplaceholder'),
            label: i18n.t('invoicesCenter.configbutionCreatetime'),
            value: '',
            resField: 'createTime',
            valueFormat: 'yyyy-MM-dd'
        },

        {
            id: '9',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.configbutionSelectupdatetimeplaceholder'),
            label: i18n.t('invoicesCenter.configbutionUpdatetime'),
            value: '',
            resField: 'updateTime',
            valueFormat: 'yyyy-MM-dd'
        }
    ],
    // 确认按钮
    sureBtnVisable: true,
    sureBtnType: 'primary',
    sureBtnSize: 'medium',
    sureBtnText: i18n.t('invoicesCenter.configbutionSearchbutton'),
    //重置按钮
    restBtnVisable: true,
    restBtnType: '',
    restBtnSize: 'medium',
    restBtnText: i18n.t('invoicesCenter.configbutionResetbutton')
}
